import { useInfiniteQuery } from '@tanstack/react-query'

import { getUpcomingTrainings } from '../functions/getUpcomingTrainings'

function useUpcomingTrainings(type: string, language: string) {
  return useInfiniteQuery(
    ['useUpcomingTrainings', language],
    ({ pageParam = 0 }) => {
      return getUpcomingTrainings(pageParam || 0, type, language)
    },
    {
      getNextPageParam: (lastPage, pages) => {
        if (pages.length * 10 <= lastPage.total) {
          return lastPage.nextOffset
        }
        return undefined
      },
    }
  )
}

export { useUpcomingTrainings }
